import { MarketInfo } from '@/domain/market-info/marketInfo'
import { TokenWithBalance } from '@/domain/common/types'
import { MarketWalletInfo } from '@/domain/wallet/useMarketWalletInfo'

const GSM_MINT_TOKENS = ['USD₮0']
const GSM_RECEIVE_TOKENS = ['USDXL']
const GSM_BURN_TOKENS = GSM_RECEIVE_TOKENS
const GSM_REDEEM_TOKENS = GSM_MINT_TOKENS

export function getGSMReserves(
  marketInfo: MarketInfo,
  walletInfo: MarketWalletInfo,
): { fromAssets: TokenWithBalance[]; toAssets: TokenWithBalance[] } {
  const { reserves } = marketInfo

  const fromAssets = reserves
    .filter((reserve) => GSM_MINT_TOKENS.includes(reserve.token.symbol))
    .map((r) => ({
      token: r.token,
      balance: walletInfo.findWalletBalanceForToken(r.token),
    }))
  const toAssets = reserves
    .filter((reserve) => GSM_RECEIVE_TOKENS.includes(reserve.token.symbol))
    .map((r) => ({
      token: r.token,
      balance: walletInfo.findWalletBalanceForToken(r.token),
    }))

  return { fromAssets, toAssets }
}

export function getGSMBurnReserves(
  marketInfo: MarketInfo,
  walletInfo: MarketWalletInfo,
): { fromAssets: TokenWithBalance[]; toAssets: TokenWithBalance[] } {
  const { reserves } = marketInfo

  const fromAssets = reserves
    .filter((reserve) => GSM_BURN_TOKENS.includes(reserve.token.symbol))
    .map((r) => ({
      token: r.token,
      balance: walletInfo.findWalletBalanceForToken(r.token),
    }))
  const toAssets = reserves
    .filter((reserve) => GSM_REDEEM_TOKENS.includes(reserve.token.symbol))
    .map((r) => ({
      token: r.token,
      balance: walletInfo.findWalletBalanceForToken(r.token),
    }))

  return { fromAssets, toAssets }
}
